module.exports = __webpack_public_path__ + "static/img/45.e532cfa4.png";